import { Section, Eyebrow, Heading } from './home-ui';
import { MediaFrame } from './hero-component';

export default function WhyChooseUs({ data }) {
    if (!data) return null;
    const { eyebrow, titleLine1, titleLine2, paragraph, bullets = [], image, imageAlt } = data;

    return (
        <Section bg="alt">
            <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
                <MediaFrame src={image} alt={imageAlt} ratio="aspect-[6/5]" label="Team photo, plans review at city counter" />
                <div>
                    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
                    <Heading line1={titleLine1} line2={titleLine2} className="mt-4" />
                    {paragraph && <p className="mt-4 text-lg text-ink-muted">{paragraph}</p>}
                    <ul className="mt-6 space-y-3">
                        {bullets.map((b) => (
                            <li key={b} className="flex items-start gap-3 text-ink">
                                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand text-sm text-white">✓</span>
                                <span>{b}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </Section>
    );
}
